import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import Sidebar from ".././Sidebar";
import { getPopoverByName, hasDidAvatar } from "../../../../utils";
import { closePopover, selectSubTab } from "../../../../store/common/uiSlice";
import ToggleSwitch from "../../ToggleSwitch";
import { CanvasContext } from "../../../editor/CanvasContext";
import { addAvatar } from "../../../../canvasUtils";
import Loader from "../../Loader";
import NewAvatar from "./NewAvatar";
import Modal from "../../modal/Modal";
import {
  setElevenLabsVoice,
  updateGeneratedVoice,
  updateSlideVoice,
  updateSlideVoiceFile,
} from "../../../../store/slides/slidesSlice";
import {
  defaultFemaleVoice,
  defaultMaleVoice,
} from "../../../../constants/states";
import { setChatGptData } from "../../../../store/script/scriptSlice";
import {
  getVoiceFromValue,
  getVoicesOfLanguage,
} from "../../../../constants/scriptConfig";
import { useParams } from "react-router-dom";
import { setIsOnlyAvatarUrl } from "../../../../store/project/projectSlice";

const AvatarPopover = () => {
  const { type, id } = useParams();
  const dispatch = useDispatch();
  const { canvas } = useContext(CanvasContext);
  const { currentSlideIndex, slides } = useSelector((state) => state.slides);
  const { avatar: isOnlyavatrExsting } = useSelector((state) => state.project);
  const { avatar: existingAvatar, currentSlide } = useMemo(() => {
    const currentSlide = slides[currentSlideIndex];
    const avatar = (currentSlide.objects || []).find(
      (obj) => obj.type === "avatar"
    );
    return { currentSlide, avatar };
  }, [slides, currentSlideIndex]);

  const { vidboardAvatars, proAvatars, userAvatars } = useSelector(
    (state) => state.avatars
  );

  const { chatGptData } = useSelector((state) => state.script);

  const { subTab } = useSelector((state) => state.ui);
  const isProAvatarTab = useMemo(() => subTab === 2, [subTab]);
  const isUserAvatarTab = useMemo(() => subTab === 1, [subTab]);
  const trial = useSelector((state) => state?.user?.details?.data?.trial);
  const maxAvatar = useSelector(
    (state) => state?.user?.details?.data?.max_custom_avatar
  );

  const hasCurrentSlideDid = (currentSlide?.objects || []).find(
    (o) => o.type === "avatar" && o.url.includes("d-id")
  );

  // const shouldDisplayOneSlide =
  //   slides.filter((slide) => {
  //     // Check if the slide has objects and any of them is an avatar with a URL including "d-id"
  //     return (
  //       slide.objects &&
  //       slide.objects.some((obj) => {
  //         return obj.type === "avatar" && obj.url.includes("d-id");
  //       })
  //     );
  //   }).length < 3;

  const slidesWithAvatarDId = slides.filter((slide) => {
    // Check if the slide has objects and any of them is an avatar with a URL including "d-id"
    return (
      slide.objects &&
      slide.objects.some((obj) => {
        return obj.type === "avatar" && obj.url.includes("d-id");
      })
    );
  });

  const shouldDisplayOneSlide = slidesWithAvatarDId.length >= 3;
  const aiCustomAvatar = useSelector(
    (state) => state?.user?.details?.data?.ai_custom_avatar
  );
  const isDidAvatar = hasDidAvatar(slides);
  const thisPopover = getPopoverByName(
    "Avatars",
    trial,
    shouldDisplayOneSlide || aiCustomAvatar,
    maxAvatar
  );
  const [confirmationAvatar, setConfirmationAvatar] = useState(null);
  const { elevenLabsVoices } = useSelector((state) => state.script);
  const { isOnlyAvatar } = useSelector((state) => state.project);

  // 3 diff. state for avatar in avatar slice
  // so managed this way
  const avatars = useMemo(
    () =>
      isUserAvatarTab
        ? userAvatars
        : isProAvatarTab
        ? proAvatars
        : vidboardAvatars,
    [
      subTab,
      userAvatars,
      vidboardAvatars,
      proAvatars,
      isUserAvatarTab,
      isProAvatarTab,
    ]
  );

  const appState = useSelector((state) => state.appState);

  const [circle, setCircle] = useState(false);
  const [newAvatar, setNewAvatar] = useState(false);

  const onTabSelect = useCallback(
    (tabIndex) => {
      dispatch(selectSubTab(tabIndex));
      dispatch(thisPopover.tabs[tabIndex].images());
    },
    [dispatch]
  );

  useEffect(() => {
    onTabSelect(0);
  }, [onTabSelect]);

  const addAvatarOnCanvas = async (avatar) => {
    return addAvatar(
      canvas,
      {
        square: !circle,
        url: avatar.image,
        gender:
          avatar.gender !== undefined ? avatar.gender.toLowerCase() : "male",
        avatarCode: isUserAvatarTab
          ? `/media${avatar.drivingVideo}`
          : avatar.avatarCode,
        user_avatar: !!isUserAvatarTab,
        pro_avatar: !!isProAvatarTab,
      },
      dispatch
    );
  };
  const handleCloseConfirmationModal = () => {
    setConfirmationAvatar(null);
    dispatch(closePopover());
  };

  const onConfirm = async (avatar) => {
    console.log("avatar", avatar);
    const isGenderChanged =
      existingAvatar?.gender &&
      (avatar.gender || "male").toLowerCase() !==
        (isOnlyAvatar
          ? (isOnlyavatrExsting?.gender).toLowerCase()
          : (existingAvatar?.gender).toLowerCase());

    // remove voice file if selected pro avatar
    const updatedToProAvatar =
      isProAvatarTab && existingAvatar && !existingAvatar?.presenterId;

    const isFemale = (avatar.gender || "").toLowerCase() === "female";
    const newVoice = isFemale ? defaultFemaleVoice : defaultMaleVoice;
    let elevenLabs = currentSlide?.elevenlabs_voice;

    const existingVoice =
      (elevenLabs && elevenLabs.languageId
        ? elevenLabs.languageId
        : currentSlide?.voice) || newVoice;
    const currentLanguage = existingVoice.slice(0, 5);

    const voiceLanguages = getVoicesOfLanguage(currentLanguage);
    const newVoiceLanguage = voiceLanguages.find(
      (v) => v.gender.toLowerCase() === (isFemale ? "female" : "male")
    ).id;
    const voices = elevenLabs ? elevenLabsVoices : voiceLanguages;

    const findVoice = voices.find(
      (v) => v.gender.toLowerCase() === (isFemale ? "female" : "male")
    );
    const voice = !isGenderChanged ? existingVoice : findVoice?.id;

    if (isGenderChanged || updatedToProAvatar) {
      dispatch(updateSlideVoiceFile(null));
      dispatch(updateGeneratedVoice(null));
      if (!!chatGptData && (chatGptData || [].length)) {
        dispatch(
          setChatGptData(
            chatGptData.map((item, index) => {
              const isEleven = item?.elevenLabVoice;
              return {
                ...item,
                elevenLabVoice: isEleven
                  ? {
                      ...item.elevenLabVoice,
                      ...(findVoice || {}),
                      languageId: !isGenderChanged
                        ? existingVoice
                        : newVoiceLanguage,
                    }
                  : undefined,
                voice: index === currentSlideIndex ? voice : item.voice,
                voiceFile: index === currentSlideIndex ? null : item.voiceFile,
              };
            })
          )
        );
      }
    }
    if (elevenLabs) {
      dispatch(
        setElevenLabsVoice({
          ...elevenLabs,
          ...(findVoice || {}),
          languageId: !isGenderChanged ? existingVoice : newVoiceLanguage,
        })
      );
    }
    dispatch(updateSlideVoice(voice));
    dispatch(
      setIsOnlyAvatarUrl({
        url: avatar.image,
        avatarCode: avatar?.userId ? avatar.drivingVideo : avatar.avatarCode,
        gender: avatar?.gender,
      })
    );
    await addAvatarOnCanvas(avatar);
    return handleCloseConfirmationModal();
  };

  const handleClick = async (avatar) => {
    console.log("handleClick", avatar);
    // dispatch(
    //   setIsOnlyAvatarUrl({
    //     url: avatar.image,
    //     avatarCode: avatar?.userId ? avatar.drivingVideo : avatar.avatarCode,
    //   })
    // );
    const isGenderChanged =
      existingAvatar?.gender &&
      (avatar.gender || "male").toLowerCase() !==
        (isOnlyAvatar
          ? (isOnlyavatrExsting?.gender).toLowerCase()
          : (existingAvatar?.gender).toLowerCase());
    console.log("isGenderChanged", isGenderChanged);
    const script = currentSlide?.script;
    const voice = currentSlide?.voice;
    const elevenLabs = currentSlide?.elevenlabs_voice;
    const voiceGender =
      getVoiceFromValue(
        elevenLabs && elevenLabs.languageId ? elevenLabs.languageId : voice
      )?.gender || avatar.gender;
    const voiceMismatch =
      voice &&
      (avatar.gender || "").toLowerCase() !== voiceGender.toLowerCase();
    if (isGenderChanged && voiceMismatch) {
      return setConfirmationAvatar(avatar);
    }
    if (script && voice) {
      if (voiceMismatch) {
        return setConfirmationAvatar(avatar);
      }
    }
    return onConfirm(avatar);
  };

  return (
    <div className="flex w-full h-full">
      {newAvatar ? (
        <NewAvatar setNewAvatar={setNewAvatar} />
      ) : (
        <>
          <Sidebar
            titleIcon={"/tool/dashboard/static/images/icons/tools/avatars.svg"}
            title={"Avatars"}
            tabs={thisPopover.tabs}
            onTabSelect={onTabSelect}
            setNewAvatar={setNewAvatar}
            uploadButton={
              isUserAvatarTab && {
                ...thisPopover.uploadButton,
                handler: () => setNewAvatar(true),
              }
            }
          />
          {confirmationAvatar && (
            <Modal
              center
              hideClose
              open={true}
              onClose={handleCloseConfirmationModal}
              onSubmit={() => onConfirm(confirmationAvatar)}
            >
              If you decide to change the avatar's gender, both the voice and
              the script will be removed.
            </Modal>
          )}
          <div className="px-2 py-4 w-4/5 bg-gray-100">
            {!isOnlyAvatar && (
              <ToggleSwitch
                textDisabled={"Circle"}
                textEnabled={"Square"}
                onEnabled={(v) => setCircle(v)}
              />
            )}
            <div className="grid grid-cols-8 gap-8 mt-2 w-full h-[calc(100%_-_50px)] overflow-y-scroll">
              {appState === "loading" ? (
                <div className="flex flex-grow h-4/5 justify-center text-sm text-gray-500 items-center text-center w-full">
                  <Loader />
                </div>
              ) : (
                avatars.map((avt, index) => (
                  <div
                    key={"avatar" + index}
                    className="w-full rounded flex justify-center items-center cursor-pointer"
                    onClick={() => handleClick(avt)}
                  >
                    <img
                      src={avt.image}
                      alt={`${index}`}
                      className={`max-w-full max-h-full ${
                        circle ? "rounded-full" : ""
                      }`}
                    />
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AvatarPopover;
